import React from 'react';
import BookDemoButton from './BookDemoButton';

const ProductSection = () => (
  <section className="icrs-container icrs-container--narrow icrs-product">
    {/* RentDirect */}
    <div className="icrs-product__block">
      <span className="icrs-product__eyebrow">Platform</span>
      <h2 className="icrs-product__title">See RentDirect&trade; in Action</h2>
      <p className="icrs-product__desc">
        RentDirect&trade; brings everything rental into one connected platform &mdash;
        bookings, renter verification, insurance, collections, tolls, roadside and more,
        all automated.
      </p>

      <div className="icrs-product__video">
        <iframe
          src="https://player.vimeo.com/video/1190651320?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          title="RentDirect"
        />
      </div>

      <div className="icrs-product__cta">
        <BookDemoButton />
      </div>
    </div>

    <div className="icrs-product__divider" />

    {/* RentID */}
    <div className="icrs-product__block">
      <span className="icrs-product__eyebrow">Trust &amp; Safety</span>
      <h2 className="icrs-product__title">Meet RentID&trade;</h2>
      <p className="icrs-product__desc">
        RentID&trade; helps rental businesses verify drivers with ID verification,
        license status checks, criminal background checks, MVRs, and insurance validation.
      </p>

      <div className="icrs-product__video">
        <iframe
          src="https://player.vimeo.com/video/1185610303?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          title="RentID"
        />
      </div>

      <div className="icrs-product__cta">
        <BookDemoButton />
      </div>
    </div>
  </section>
);

export default ProductSection;
